import { Button as ButtonBase, type ButtonProps } from "@heroui/react";

import { useAudio } from "@/contexts/AudioContext";

export const Button = ({
  silent,
  onPress,
  onClick,
  children,
  variant,
  className,
  ...props
}: ButtonProps & {
  silent?: boolean;
  /**
   * This is undocumented but supported by ButtonBase
   */
  showAnchorIcon?: boolean;
}) => {
  const Audio = useAudio();
  const buttonClassName = ["canvas-button", className].filter(Boolean).join(" ");

  return (
    <ButtonBase
      {...props}
      className={buttonClassName}
      variant={variant ?? "faded"}
      onPress={(e) => {
        onPress?.(e);
        if (onPress && !silent) {
          Audio.play("UI_CLICK");
        }
      }}
      onClick={(e) => {
        onClick?.(e);
        if (onClick && !silent) {
          Audio.play("UI_CLICK");
        }
      }}
    >
      {children}
    </ButtonBase>
  );
};
